import { Tabs as PrimitiveTabs } from "@ark-ui/react";
import type { ComponentProps } from "react";
import List from "./List/List";
import Trigger from "./Trigger/Trigger";
import Content from "./Content/Content";
import { TabsProvider, type TabsLayout, type TabsColor } from "./TabsContext";

type CustomProps = {
  layout?: TabsLayout;
  color?: TabsColor;
};

type Props = ComponentProps<typeof PrimitiveTabs.Root> & CustomProps;

const TabsRoot = ({ layout = "fill", color = "primary", children, ...rest }: Props) => (
  <TabsProvider layout={layout} color={color}>
    <PrimitiveTabs.Root {...rest}>{children}</PrimitiveTabs.Root>
  </TabsProvider>
);

export const Tabs = Object.assign(TabsRoot, {
  List,
  Trigger,
  Content,
});
